"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FolderOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M4 27h24a2 2 0 002-2V9a2 2 0 00-2-2H15.5l-1.7-2.5a1 1 0 00-.9-.5H4a2 2 0 00-2 2v19a2 2 0 002 2zM4 6h8.4l1.4 2.1.6.9H28v16H4z"/><path d="M25 11H14.4a2 2 0 00-1.4.6L11.6 13H7a1 1 0 000 2h4.6a2 2 0 001.4-.6l1.4-1.4H25a1 1 0 000-2z"/>';
var FolderOutlineSVG = function FolderOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.FolderOutlineSVG = FolderOutlineSVG;
FolderOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FolderOutlineSVG);
exports.default = _default;